import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "item", "template", "addButton"]
  static values = { maxUbos: Number, titleTemplate: String }

  connect() {
    this.renumberItems()
    this.openFirstItem()
    this.updateAddButtonVisibility()
  }

  add() {
    const clone = this.templateTarget.content.cloneNode(true)
    const timestamp = new Date().getTime()

    clone.querySelectorAll("*").forEach(element => {
      for (const attr of element.attributes) {
        if (attr.value.includes("NEW_RECORD")) {
          attr.value = attr.value.replaceAll("NEW_RECORD", timestamp)
        }
      }
    })

    this.containerTarget.appendChild(clone)
    this.renumberItems()
    this.updateAddButtonVisibility()

    const items = this.visibleItems()
    const lastItem = items[items.length - 1]
    this.expandItem(lastItem)
  }

  remove(event) {
    const item = event.target.closest("[data-dynamic-ubo-target='item']")
    const destroyField = item.querySelector("[data-destroy-field]")

    if (destroyField) {
      destroyField.value = "1"
      this.clearInputs(item)
      item.style.display = "none"
    } else {
      item.remove()
    }

    this.renumberItems()
    this.updateAddButtonVisibility()
  }

  toggle(event) {
    const item = event.target.closest("[data-dynamic-ubo-target='item']")
    const content = item.querySelector("[data-dynamic-ubo-target='content']")
    const icon = item.querySelector("[data-dynamic-ubo-target='icon']")
    const button = event.currentTarget
    const expanded = button.getAttribute("aria-expanded") === "true"

    content.classList.toggle("hidden")
    icon.classList.toggle("rotate-180")
    button.setAttribute("aria-expanded", String(!expanded))
  }

  // private

  visibleItems() {
    return this.itemTargets.filter(item => item.style.display !== "none")
  }

  renumberItems() {
    let number = 1
    this.itemTargets.forEach(item => {
      if (item.style.display === "none") return

      const title = item.querySelector("[data-ubo-title]")
      if (title) {
        title.textContent = this.titleTemplateValue.replace("%{number}", number)
      }

      const removeButton = item.querySelector("[data-ubo-remove]")
      if (removeButton) {
        removeButton.classList.toggle("hidden", number === 1)
      }

      number++
    })
  }

  expandItem(item) {
    const content = item.querySelector("[data-dynamic-ubo-target='content']")
    const icon = item.querySelector("[data-dynamic-ubo-target='icon']")
    const button = item.querySelector("[data-dynamic-ubo-target='toggleButton']")

    if (content) content.classList.remove("hidden")
    if (icon) icon.classList.add("rotate-180")
    if (button) button.setAttribute("aria-expanded", "true")
  }

  collapseItem(item) {
    const content = item.querySelector("[data-dynamic-ubo-target='content']")
    const icon = item.querySelector("[data-dynamic-ubo-target='icon']")
    const button = item.querySelector("[data-dynamic-ubo-target='toggleButton']")

    if (content) content.classList.add("hidden")
    if (icon) icon.classList.remove("rotate-180")
    if (button) button.setAttribute("aria-expanded", "false")
  }

  openFirstItem() {
    this.visibleItems().forEach((item, index) => {
      if (index === 0) {
        this.expandItem(item)
      } else {
        this.collapseItem(item)
      }
    })
  }

  updateAddButtonVisibility() {
    if (!this.hasAddButtonTarget) return

    const visibleCount = this.visibleItems().length
    this.addButtonTarget.classList.toggle("hidden", visibleCount >= this.maxUbosValue)
  }

  clearInputs(item) {
    item.querySelectorAll("input, select, textarea").forEach(input => {
      if (input.dataset.destroyField !== undefined) return

      if (input.type === "checkbox" || input.type === "radio") {
        input.checked = false
      } else {
        input.value = ""
      }
    })
  }
}
